(() => {
  if (window.__rnfDecorationVisibility || !('IntersectionObserver' in window)) return;
  window.__rnfDecorationVisibility = true;
  const selector = ".rnf-why__anim,.section-divider__svg .parallax1 > use,.section-divider__svg .parallax2 > use,.section-divider__svg .parallax3 > use,.section-divider__svg .parallax4 > use,.custom-marquee .track,[class*=\"marquee-horizontal-\"] > [class*=\"track-horizontal-\"],.rnf-mpc__bar,.rnf-mpc__box,.rnf-mpc__track,.rnf-shipicon__body,.rnf-shipicon__line,.rnf-pulse,.rnf-freeship__dot,.rnf-freeship__ring,.rnf-ob__bullet,.rnf-spin-wheel-badge__img,.rnf-carousel-flash .rnf-carousel-flash__pill,.rnf-why__surface,.rnf-maincard__badge-stack .rnf-maincard__badge--flash,.rnf-maincard__ping";
  const roots = new Set();
  const flashes = new Map();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      entry.target.toggleAttribute('data-rnf-decoration-paused', !entry.isIntersecting);
    });
  }, { rootMargin: '150px 0px' });
  const flashObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      flashes.get(entry.target)?.toggleAttribute('data-rnf-decoration-paused', !entry.isIntersecting || entry.intersectionRatio <= 0);
    });
  }, { rootMargin: '0px', threshold: 0 });

  function mount(scope) {
    scope.querySelectorAll(selector).forEach(element => {
      const flash = element.closest('.rnf-carousel-flash');
      if (flash) {
        if (flashes.has(flash)) return;
        const owner = flash.closest('.rnf-card-wrap') || flash.parentElement;
        if (!owner) return;
        owner.setAttribute('data-rnf-decoration-paused', '');
        flashes.set(flash, owner);
        flashObserver.observe(flash);
        return;
      }
      // Observe a stationary owner, never a translating marquee track.
      const root = element.closest('.rnf-maincard, .rnf-shipicon, .rnf-pack-toprow, .rnf-ob, .shopify-section');
      if (!root || roots.has(root)) return;
      roots.add(root);
      observer.observe(root);
    });
  }

  function visibility() {
    document.documentElement.toggleAttribute('data-rnf-page-hidden', document.hidden);
  }

  function init() {
    visibility();
    mount(document);
    document.addEventListener('visibilitychange', visibility);
    document.addEventListener('shopify:section:load', event => mount(event.target));
    document.addEventListener('shopify:section:unload', event => {
      flashes.forEach((owner, flash) => {
        if (!event.target.contains(flash)) return;
        flashObserver.unobserve(flash);
        owner.removeAttribute('data-rnf-decoration-paused');
        flashes.delete(flash);
      });
      roots.forEach(root => {
        if (!event.target.contains(root)) return;
        observer.unobserve(root);
        root.removeAttribute('data-rnf-decoration-paused');
        roots.delete(root);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
